var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { jsx } from "react/jsx-runtime";
import "../TextField/index.js";
import { TextField as TextField$1 } from "../TextField/TextField.js";
const SearchCommandBarTextField = (props) => {
  return /* @__PURE__ */ jsx("div", { role: "menuitem", children: /* @__PURE__ */ jsx(
    TextField$1,
    __spreadValues({
      styles: {
        fieldGroup: {
          border: "none",
          backgroundColor: "transparent",
          height: "40px"
        },
        field: {
          paddingLeft: "32px",
          paddingRight: "12px"
        },
        icon: {
          left: "8px",
          lineHeight: "40px",
          top: "0px"
        }
      }
    }, props)
  ) });
};
export {
  SearchCommandBarTextField
};
//# sourceMappingURL=SearchCommandBarTextField.js.map
